import { Controller } from "@hotwired/stimulus";

import Sortable from "sortablejs";

// Implements https://sortablejs.github.io/Sortable/
export default class extends Controller {
	static classes = ["drag", "ghost", "chosen", "filtered", "handle"];
	static values = {
		animation: { type: Number, default: 150 },
	};
	static outlets = ["autosubmit"];

	connect() {
		const options = {
			// Always use SortableJS's own floating clone instead of the browser's
			// native drag image: the native one is an unstyled, often-transparent
			// snapshot that overlaps the placeholder left behind in the list.
			forceFallback: true,
			fallbackOnBody: true,
			animation: this.animationValue,
			onStart: this.start.bind(this),
			onEnd: this.end.bind(this),
		};

		if (this.hasHandleClass) options.handle = `.${this.handleClass}`;
		if (this.hasFilteredClass) options.filter = `.${this.filteredClass}`;
		if (this.hasDragClass) options.dragClass = this.dragClass;
		if (this.hasGhostClass) options.ghostClass = this.ghostClass;
		if (this.hasChosenClass) options.chosenClass = this.chosenClass;

		this.sortable = new Sortable(this.element, options);
	}

	disconnect() {
		this.sortable.destroy();
		this.sortable = undefined;
	}

	start() {
		// Dispatch event before sort starts so editors can sync their content
		this.element.dispatchEvent(new CustomEvent("sortable:start", { bubbles: true }));
	}

	end() {
		this.autosubmitOutlets.forEach((autosubmit) => {
			autosubmit.immediateSubmit();
		});

		// Dispatch custom event for other controllers to listen to
		this.element.dispatchEvent(new CustomEvent("sortable:end", { bubbles: true }));
	}
}
